import { useEffect, useState } from 'react';

import { DEFAULT_LANGUAGE, LANGUAGES } from './languages';
import { useCVLanguage } from './language.component';

// The document pages - get started, the guide, the story, privacy and terms -
// are written out whole once per language, in a locales/ folder beside each
// page. English ships with the page; each other language is fetched the first
// time someone reads that page in it.
//
//     const GUIDE = localizedPage(english, code => import(`./locales/guide.${code}`))
//     const [page, lang] = useLocalizedPage(GUIDE)
//
// `lang` is the language `page` is in: the reader's, or English when the
// translation cannot be fetched. Both are null for the moment a first
// translation takes to arrive; after that, switching language keeps the page
// on screen until the new one is ready.

export const localizedPage = (english, load) => ({
    loaded: { [DEFAULT_LANGUAGE]: english },
    load
})

const translated = code => code !== DEFAULT_LANGUAGE && LANGUAGES.some(language => language.code === code)

export const useLocalizedPage = pages => {
    const { code } = useCVLanguage();
    const [shown, setShown] = useState(() => (pages.loaded[code] ? code : null));

    useEffect(() => {
        let current = true;

        if (pages.loaded[code]) {
            setShown(code);
        } else if (!translated(code)) {
            setShown(DEFAULT_LANGUAGE);
        } else {
            pages.load(code).then(
                module => {
                    pages.loaded[code] = module.default;

                    if (current) {
                        setShown(code);
                    }
                },
                // offline, or no such translation: English, which is always here
                () => { if (current) setShown(DEFAULT_LANGUAGE) }
            )
        }

        return () => { current = false }
    }, [code, pages])

    return shown ? [pages.loaded[shown], shown] : [null, null]
}
